// Controle das flags de onboarding (boas-vindas, tour guiado e checklist).
//
// Antes, cada componente gravava uma chave GLOBAL no localStorage
// (ex.: "me_welcome_modal_seen"), o que dispensava o aviso para qualquer
// conta usada no mesmo navegador. Agora a flag é escopada por
// empresa + usuário, então cada conta tem o seu próprio estado.
//
// Não usamos fallback para a chave global antiga de propósito: como ainda
// não há clientes ativos, quem testa criando várias contas no mesmo
// navegador precisa que cada conta nova seja tratada como primeiro acesso.
// Contas já configuradas são protegidas pela auto-supressão (ver
// useOnboardingStatus.isEstablished), não pela flag.

export const scopedKey = (baseKey) => {
  const companyId = localStorage.getItem("companyId") || "0";
  const userId = localStorage.getItem("userId") || "0";
  return `${baseKey}:${companyId}:${userId}`;
};

export const isOnboardingFlagSet = (baseKey) =>
  !!localStorage.getItem(scopedKey(baseKey));

export const setOnboardingFlag = (baseKey) => {
  localStorage.setItem(scopedKey(baseKey), "1");
};
